{
  "datatable": {
    "rowsPerPage": "Строк на странице"
  },
  "department": {
    "addDepartment": "Добавить Департамент",
    "createNewDepartment": "Создать Новый Департамент",
    "departmentAdmin": "Администратор Департамена",
    "departmentName": "Название Департамента",
    "institution": "Название Учреждения",
    "institutionName": "Название Учреждения",
    "searchDepartments": "Поиск департамента",
    "thisFieldIsRequired": "Обязательное Поле"
  },
  "general": {
    "accessDenied": "Нет Доступа",
    "add": "Дообавить",
    "back": "Назад",
    "cancel": "Отмена",
    "close": "Закрыть",
    "dateAdded": "Добавлено",
    "dateUpdated": "Обновлено",
    "delete": "Удалить",
    "edit": "Редактировать",
    "loading": "Загрузка ...",
    "no": "Нет",
    "noData": "Нет Данных",
    "ok": "ОК",
    "remove": "Удалить",
    "save": "Сохранить",
    "selectAll": "Выбрать Все",
    "yes": "Да"
  },
  "institution": {
    "contact": "Контакт",
    "createNewInstitution": "Создать новое учреждение",
    "name": "Имя",
    "region": "Регион",
    "searchInstitutions": "Поиск учреждений",
    "switch": "Переключить",
    "switchedTo": "Учреждение изменено на",
    "unableToSwitch": "Невозможно переключить"
  },
  "menu": {
    "departments": "Департаменты",
    "home": "Главная",
    "institutions": "Institutions",
    "procedure": "Процедура",
    "procedures": "Процедуры",
    "scheduling": "Расписание",
    "users": "Пользователи"
  },
  "procedure": {
    "allSteps": "Все Шаги",
    "authors": "Автор(ы)",
    "category": "Категория",
    "createNewStep": "Создать Новый Шаг",
    "defineFeedback": "Оставить обратную связь",
    "description": "Описание",
    "disableProcedure": "Отключить Процедуру",
    "editProceduresInformation": "Редактировать Информацию о Процедуре",
    "information": "Информация",
    "language": "Язык",
    "languagesAvailable": "Доступные языки",
    "media": "Медиа",
    "name": "Имя",
    "owner": "Владелец",
    "procedureCategory": "Категория Процедуры",
    "procedureLanguage": "Язык Процедуры",
    "procedureName": "Имя Процедуры",
    "procedureNotFound": "Процедура не найдена",
    "public": "Общая",
    "publicPrivate": "Общие/Внутренние",
    "revisionHistory": "История Ревизий",
    "searchSteps": "Искать шаг(и)",
    "seeFeedback": "Смотреть обратную связь",
    "statistics": "Статистика",
    "step": "Шаг",
    "thisFieldIsRequired": "Обязательное поле",
    "unableToLoad": "Ошибка во время загрузки процедур",
    "viewAs": "Смотреть Как"
  },
  "procedures": {
    "addProcedure": "Добавить процедуру",
    "category": "Категория",
    "deleteProcedure": "Удалить процедуру",
    "department": "Департамент",
    "filter": "Фильтр",
    "private": "Внутренние",
    "procedures": "Процедуры",
    "public": "Общие",
    "publicPrivate": "Общие/Внутренние",
    "searchProcedures": "Поиск процедур",
    "sort": "Сортировать"
  },
  "step": {
    "addDescription": "Добавить Описание",
    "addParentStep": "Добавить родительский шаг",
    "chooseParentSep": "Выберите Родительский Шаг",
    "chooseStepOption": "Выберите вариант шага",
    "chooseTransitionType": "Выберите тип перехода",
    "chooseType": "Выберите тип",
    "description": "Описание",
    "dropFilesOrClickToUpload": "Перетащите файлы сюда или нажмите Загрузить",
    "editStep": "Редактировать Шаг",
    "insertMaxValue": "Введите МАКС значение",
    "insertMinValue": "Введите МИН значение",
    "insertOption": "Вариант ввода",
    "option": "Опция",
    "owner": "Владелец",
    "parentStep": "Родительский Шаг",
    "previousStep": "Предыдущий Шаг",
    "saveMedia": "Сохранить Медиа",
    "stepMedia": "Медиафайлы Шага",
    "transitionToNextStep": "Переход на следующий шаг",
    "transitionType": "Тип Перехода",
    "type": "Тип",
    "value": "Значение",
    "viewInProcedure": "Смотреть в Процедуре"
  },
  "user": {
    "accountSettings": "Настройки аккаунта",
    "chooseUserRole": "Выберите Роль Пользователя",
    "contact": "Контакт",
    "contactInformation": "Контактная информация",
    "dateOfBirth": "Дата Рождения",
    "department": "Департамент",
    "emails": "Емейл Пользователя",
    "emailsDescription": "Введите 1 или более емейл адресов, разделенных точкой с запятой. Пользователю будет отправлено приглашение зарегестрироваться с выбранной ролью на емейл.",
    "filter": "Фильтр",
    "gender": "Пол",
    "institution": "Учреждение",
    "institutionalAdmin": "Администратор Учреждения",
    "institutionAndDepartment": "Учреждение и Департамент",
    "inviteUsers": "Пригласить Пользователя",
    "logOut": "Выйти",
    "nurse": "Медсестра",
    "password": "Пароль",
    "patient": "Пациент",
    "resetPassword": "Сбросить Пароль",
    "resetRequestSentTo": "Письмо с данными о сбросе паролья отправлен на",
    "searchUsers": "Поиск пользователя",
    "sendResetPasswordEmailTo": "Отправить письмо с данными о сбросе пароля на",
    "sort": "Сортировка",
    "subscription": "Подписка",
    "thisFieldIsRequired": "Обязательное поле",
    "user": "Пользователь",
    "userDetailsUpdated": "Данные о пользователе обновлены",
    "userInformation": "Пользовательская информация",
    "userRole": "Роль Пользователя"
  }
}